import { IMG_PRODUCTS } from './mockShared';

export const STATUSES = [
  { key: 'aguardando_atendimento', label: 'Aguardando Atendimento', color: '#0284C7' },
  { key: 'em_atendimento', label: 'Em Atendimento', color: '#D97706' },
  { key: 'proposta_em_preparacao', label: 'Proposta em Preparação', color: '#7C3AED' },
  { key: 'proposta_enviada', label: 'Proposta Enviada', color: '#2563EB' },
  { key: 'aguardando_cliente', label: 'Aguardando Cliente', color: '#0891B2' },
  { key: 'concluida', label: 'Concluída', color: '#059669' },
  { key: 'cancelada', label: 'Cancelada', color: '#DC2626' },
];

export const statusLabel = (key) => STATUSES.find((s) => s.key === key)?.label || key;
export const statusColor = (key) => STATUSES.find((s) => s.key === key)?.color || '#475569';

const H = (time, text) => ({ time, text });
const minutesAgo = (m) => new Date(Date.now() - m * 60000).toISOString();

export function seedRequests() {
  return [
    {
      id: 1058,
      customer: 'Maria Fernanda Lopes',
      whatsapp: '(41) 99812-3344',
      city: 'Curitiba/PR',
      date: minutesAgo(4),
      status: 'aguardando_atendimento',
      assignedTo: null,
      proposalValue: null,
      observations: 'É para um vestido de festa de casamento em julho.',
      items: [
        { slug: 'linho-misto', variantId: 'natural', name: 'Linho Misto', variantName: 'Natural', meters: 3, image: IMG_PRODUCTS['linho-misto'] },
        { slug: 'crepe-dior', variantId: 'rosa-antigo', name: 'Crepe Dior', variantName: 'Rosa antigo', meters: 5, image: IMG_PRODUCTS['crepe-dior'] },
      ],
      history: [H(new Date(minutesAgo(4)).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }), 'Solicitação recebida pelo site')],
    },
    {
      id: 1057,
      customer: 'João Pedro Antunes',
      whatsapp: '(41) 99755-8821',
      city: 'São José dos Pinhais/PR',
      date: minutesAgo(12),
      status: 'aguardando_atendimento',
      assignedTo: null,
      proposalValue: null,
      observations: '',
      items: [
        { slug: 'la-fria', variantId: 'azul-marinho', name: 'Lã Fria', variantName: 'Azul-marinho', meters: 4, image: IMG_PRODUCTS['la-fria'] },
        { slug: 'oxford-algodao', variantId: 'azul-claro', name: 'Oxford Algodão', variantName: 'Azul claro', meters: 2.5, image: IMG_PRODUCTS['oxford-algodao'] },
      ],
      history: [H(new Date(minutesAgo(12)).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }), 'Solicitação recebida pelo site')],
    },
    {
      id: 1056,
      customer: 'Ana Beatriz Soares',
      whatsapp: '(41) 99631-2098',
      city: 'Curitiba/PR',
      date: '2026-06-09T11:15:00',
      status: 'em_atendimento',
      assignedTo: 'joao',
      proposalValue: null,
      observations: 'Prefiro retirar na loja.',
      items: [
        { slug: 'tricoline-estampada', variantId: 'floral-rosa', name: 'Tricoline Estampada', variantName: 'Floral rosa', meters: 2, image: IMG_PRODUCTS['tricoline-estampada'] },
        { slug: 'tricoline-estampada', variantId: 'xadrez-vermelho', name: 'Tricoline Estampada', variantName: 'Xadrez vermelho', meters: 1.5, image: 'https://static.prod-images.emergentagent.com/jobs/d339d82d-0dd2-4f32-aba3-f3f38b026a7c/images/ea4c8c52c520fe94b51cbd302b814ff14fb9e2d9e3e96588e627dde7880128d8.jpeg' },
        { slug: 'linho-rustico', variantId: 'cru', name: 'Linho Rústico', variantName: 'Cru', meters: 1, image: IMG_PRODUCTS['linho-rustico'] },
      ],
      history: [H('11:15', 'Solicitação recebida pelo site'), H('11:18', 'João aceitou o atendimento')],
    },
    {
      id: 1055,
      customer: 'Carla Regina Matos',
      whatsapp: '(41) 99144-7712',
      city: 'Colombo/PR',
      date: '2026-06-08T14:02:00',
      status: 'proposta_enviada',
      assignedTo: 'fernanda',
      proposalValue: 714.0,
      observations: 'Sofá de 3 lugares, preciso de orientação sobre metragem.',
      items: [
        { slug: 'jacquard-geometrico', variantId: 'azul-cru', name: 'Jacquard Geométrico', variantName: 'Azul e cru', meters: 6, image: IMG_PRODUCTS['jacquard-geometrico'] },
      ],
      history: [
        H('14:02', 'Solicitação recebida pelo site'),
        H('14:10', 'Fernanda aceitou o atendimento'),
        H('14:35', 'Proposta iniciada'),
        H('14:48', 'Proposta enviada ao cliente'),
      ],
    },
    {
      id: 1054,
      customer: 'Renata Camargo',
      whatsapp: '(41) 99877-1203',
      city: 'Curitiba/PR',
      date: '2026-06-08T10:31:00',
      status: 'aguardando_cliente',
      assignedTo: 'fernanda',
      proposalValue: 890.5,
      observations: '',
      items: [
        { slug: 'veludo-royal', variantId: 'azul-royal', name: 'Veludo Royal', variantName: 'Azul royal', meters: 3.5, image: IMG_PRODUCTS['veludo-royal'] },
        { slug: 'tule-bordado', variantId: 'azul-noite', name: 'Tule Bordado', variantName: 'Azul noite', meters: 2, image: IMG_PRODUCTS['tule-bordado'] },
      ],
      history: [
        H('10:31', 'Solicitação recebida pelo site'),
        H('10:34', 'Fernanda aceitou o atendimento'),
        H('10:52', 'Proposta enviada ao cliente'),
        H('11:05', 'Aguardando retorno do cliente'),
      ],
    },
    {
      id: 1053,
      customer: 'Ateliê Costura Criativa',
      whatsapp: '(41) 99210-5540',
      city: 'Pinhais/PR',
      date: '2026-06-07T15:48:00',
      status: 'concluida',
      assignedTo: 'carlos',
      proposalValue: 1240.0,
      observations: 'Cliente recorrente, ateliê de artesanato.',
      items: [
        { slug: 'tricoline-estampada', variantId: 'floral-rosa', name: 'Tricoline Estampada', variantName: 'Floral rosa', meters: 10, image: IMG_PRODUCTS['tricoline-estampada'] },
        { slug: 'linho-rustico', variantId: 'cru', name: 'Linho Rústico', variantName: 'Cru', meters: 5, image: IMG_PRODUCTS['linho-rustico'] },
      ],
      history: [
        H('15:48', 'Solicitação recebida pelo site'),
        H('15:50', 'Carlos aceitou o atendimento'),
        H('16:12', 'Proposta enviada ao cliente'),
        H('16:40', 'Cliente confirmou — atendimento concluído'),
      ],
    },
    {
      id: 1052,
      customer: 'Fernando Hirata',
      whatsapp: '(41) 99666-3341',
      city: 'Curitiba/PR',
      date: '2026-06-06T09:12:00',
      status: 'concluida',
      assignedTo: 'joao',
      proposalValue: 312.8,
      observations: '',
      items: [
        { slug: 'moletinho-felpado', variantId: 'mescla', name: 'Moletinho Felpado', variantName: 'Mescla', meters: 4, image: IMG_PRODUCTS['moletinho-felpado'] },
        { slug: 'ribana', variantId: 'terracota', name: 'Ribana', variantName: 'Terracota', meters: 1, image: IMG_PRODUCTS['ribana'] },
      ],
      history: [H('09:12', 'Solicitação recebida pelo site'), H('09:15', 'João aceitou o atendimento'), H('09:47', 'Atendimento concluído')],
    },
    {
      id: 1051,
      customer: 'Juliana Meireles',
      whatsapp: '(41) 98802-4417',
      city: 'Araucária/PR',
      date: '2026-06-05T17:20:00',
      status: 'cancelada',
      assignedTo: 'carlos',
      proposalValue: null,
      observations: 'Cortinas para sala e quarto.',
      items: [
        { slug: 'decoracao-linho-rustico', variantId: 'natural', name: 'Linho Rústico para Decoração', variantName: 'Natural', meters: 8, image: IMG_PRODUCTS['decoracao-linho-rustico'] },
      ],
      history: [H('17:20', 'Solicitação recebida pelo site'), H('17:25', 'Carlos aceitou o atendimento'), H('17:52', 'Solicitação cancelada a pedido do cliente')],
    },
  ];
}

export function timeAgo(iso) {
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 60) return 'agora mesmo';
  const m = Math.floor(s / 60);
  if (m < 60) return `há ${m} min`;
  const h = Math.floor(m / 60);
  if (h < 24) return `há ${h} h`;
  const d = Math.floor(h / 24);
  return `há ${d} ${d === 1 ? 'dia' : 'dias'}`;
}
